<app-header [progress]="5" [title]="locale.currentTranslation.accuracyOfInformationHeader" data-testid="data-is-correct-header"></app-header>
<div class="base-content-container" data-testid="data-is-correct-container">
  <div class="headline3" data-testid="data-is-correct-title">{{ locale.currentTranslation.dataIsCorrect1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="confirmation-form">
    <div class="radio-button-base" data-testid="checkbox-confirmation">
      <div>
        <input type="checkbox"
          [value]="dataIsCorrect"
          [formControl]="checkboxControl"
          (change)="onCheckboxChange()"
          data-testid="checkbox-data-correct"
          aria-describedby="checkbox-label"
          >
      </div>
      <div (click)="onCheckboxChange()" data-testid="checkbox-label-container">
        <div class="label1" id="checkbox-label" data-testid="checkbox-headline">{{ locale.currentTranslation.dataIsCorrectInputHeadline }}</div>
        <div class="caption1" style="margin-top: 4px;" data-testid="checkbox-caption-1">{{ locale.currentTranslation.dataIsCorrectInputCaption1 }}</div>
        <div class="caption1" style="margin-top: 12px;" data-testid="checkbox-caption-2">{{ locale.currentTranslation.dataIsCorrectInputCaption2 }}</div>
      </div>
    </div>
  </div>

  @if (showErrorMessage) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.dataCorrectErrorMessage }}
    </div>
  }
  <div class="divider"></div>
  <div class="card-info" data-testid="disclaimer-card">
    <div style="display: flex; align-items: center; gap: 8px;">
      <img ngSrc="../../../../../assets/img/info-icon.svg" height="20" width="20">
      <div class="headline4" style="color: #0A1535;">{{ locale.currentTranslation.important }}</div>
    </div>
    <div class="text-body2">
      <div>
        {{ locale.currentTranslation.dataIsCorrectDisclaimer1 }}
      </div>
      <div style="margin-top: 21px;">
        {{ locale.currentTranslation.dataIsCorrectDisclaimer2 }}
      </div>
      <ul data-testid="disclaimer-list">
        <li >
          {{ locale.currentTranslation.dataIsCorrectDisclaimer3 }}
        </li>
        <li >
          {{ locale.currentTranslation.dataIsCorrectDisclaimer4 }}
        </li>
        <li >
          {{ locale.currentTranslation.dataIsCorrectDisclaimer5 }}
        </li>
        <li >
          {{ locale.currentTranslation.dataIsCorrectDisclaimer6 }}
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.dataIsCorrectNext }}</button>
</div>
<app-footer data-testid="data-is-correct-footer"></app-footer>
